import { NgForOf, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { ComposedLoaderSettings } from '@modules/loaders/interfaces/composed-loader-settings.interface';
import { LoaderService } from '@modules/loaders/services/loader.service';

@Component({
  selector: 'app-spinner-loader',
  templateUrl: './spinner-loader.component.html',
  styleUrls: ['./spinner-loader.component.css'],
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
  ],
})
export class SpinnerLoaderComponent {
  loader: ComposedLoaderSettings;

  constructor(
    loaderService: LoaderService,
  ) {
    this.loader = loaderService.composedLoaderSettings.getValue();
    loaderService.composedLoaderSettings.subscribe(result => {
      this.loader = result;
    });
  }
}
